import React, { useContext, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
// Header2'nin yolunu doğru varsayıyorum.
import Header2 from "../../header2/index-two";
import "./apply.css";
import { Globe, BarChart2, Lock, DollarSign, Mail, Phone, Shield, FileText, FilePlus, Clipboard, Share2, UserCheck } from 'react-feather';
import { Footer2 } from "../../footer2";

import { useNavigate } from 'react-router-dom';
import InputMask from 'react-input-mask';
import { templatesandattributedataListPublisherFront } from '../../../services/publisherstemplatesandattributeService';
import { templatesListFront } from '../../../services/TemplateService';
import { AppContext } from '../../../services/AuthContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getSSS, getBasvuruSureci, getDortluIconlar, getKazanacaklarimiz } from "../../../services/directusService";
import { getCountryLanguageList, getPublicationLanguageList } from "../../../services/publisherService";
import KvkkModal from "../static/KvkkModal";
import ParticipationAgreementModal from "../static/ParticipationAgreementModal";
import ApplySuccessModal from "./ApplySuccessModal";



const isValidEmail = (v = '') => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v).trim());
const PHONE_DIGIT_TARGET = 12;
const onlyDigitsLen = (v = '') => String(v).replace(/\D/g, '').length;
const isValidPhone = (v = '') => onlyDigitsLen(v) === PHONE_DIGIT_TARGET;

const FALLBACK_SSS = [
    { id: 0, title: "1. Başvuru süreci nasıl ilerler?", description: "Başvurunuzu online form aracılığıyla gönderirsiniz. Ekibimiz ön inceleme yapar, gerekirse ek bilgi talep eder ve sonuç hakkında bilgilendirme yapar. Genellikle 3-5 iş günü içinde ön geri dönüş sağlanır." },
    { id: 1, title: "2. Hangi yayın türleri kabul ediliyor?", description: "Akademik kitaplar, konferans ve armağanlar ve hakemli dergiler gibi birçok akademik yayın türünü kabul ediyoruz." },
    { id: 2, title: "3. Kurumsal e-posta zorunlu mu?", description: "Kurumsal e-posta başvurularda tercih edilir; ancak istisnai durumlarda alternatif iletişim yöntemleri değerlendirilir." },
    { id: 3, title: "4. Başvuru ne kadar sürede sonuçlanır?", description: "Ön inceleme genellikle 3-5 iş günü içinde tamamlanır." }
];

const FALLBACK_PROCESS = [
    { title: "Başvurunuzu Başlatın", description: "Kısa formu doldurarak başvuru sürecini başlatın — sadece birkaç dakikanızı alır." },
    { title: "Yayınlarınızın İçerik Bilgisini Belirtin", description: "Yayın türü, konu alanı ve beklentileriniz gibi bilgileri içeren tanıtıcı bir metni not alanına ekleyin." },
    { title: "Değerlendirme Süreci", description: "Ekibimiz başvurunuzu inceler ve en kısa sürede geri bildirim sağlar." },
    { title: "İş Birliği ve Yayınlama", description: "Kabul sonrası kurulum, arşiv aktarımı ve yayın planını birlikte yürütelim." }
];

const FALLBACK_ADVANTAGES = [
    { title: "Geniş Dağıtım Ağı", description: "Kütüphaneler, üniversiteler ve araştırma kurumları üzerinden yayınlarınız daha geniş bir kullanıcıya ulaşır." },
    { title: "Yüksek Görünürlük ve Etkileşim", description: "Araştırmacılar ve öğrenciler yayınlarınıza daha kolay erişir; atıf ve kullanım olasılığı artar." },
    { title: "Güvenli Arşivleme", description: "Yayınlarınız profesyonel arşivleme süreçleriyle korunur ve uzun vadeli erişime hazır tutulur." },
    { title: "DRM Altyapısı ile Güçlendirilmiş Güvenlik", description: "DRM altyapısıyla içerikler telif haklarına uygun biçimde korunur." }
];

const FALLBACK_KAZANIMLAR = [
    { text: "Ulusal ve uluslararası görünürlüğünüz artar," },
    { text: "Akademik okuyucu ve kurumlara erişim sağlarsınız," },
    { text: "Dijital arşiviniz güvenle korunur," }
];

const TARGET_ATTR_LABELS = {
    address: 'Adres',
    corpPhone: 'Telefon',
    corpEmail: 'E-mail',
    taxOffice: 'Vergi Dairesi',
    taxNumber: 'Vergi No',
};

const norm = (s = '') =>
    String(s).toLowerCase().replace(/\s+/g, ' ').replace(/[()]/g, '').trim();
const isEmpty = (v) => !String(v ?? '').trim();

const ApplyPage = () => {
    const navigate = useNavigate();
    const { auth } = useContext(AppContext);
    const token = auth?.token;

    const [sss, setSss] = useState(FALLBACK_SSS);
    const [processSteps, setProcessSteps] = useState(FALLBACK_PROCESS);
    const [advantages, setAdvantages] = useState(FALLBACK_ADVANTAGES);
    const [kazanimlar, setKazanimlar] = useState(FALLBACK_KAZANIMLAR);

    const [openFaq, setOpenFaq] = useState(0);
    const { pathname } = useLocation();

    // Directus Veri Loglama
    useEffect(() => {
        const fetchDirectusData = async () => {
            try {
                const [sssRes, processRes, iconRes, kazanRes] = await Promise.all([
                    getSSS(),
                    getBasvuruSureci(),
                    getDortluIconlar(),
                    getKazanacaklarimiz()
                ]);

                if (sssRes?.data?.length) setSss(sssRes.data);
                if (processRes?.data?.length) setProcessSteps(processRes.data);
                if (iconRes?.data?.length) setAdvantages(iconRes.data);
                if (kazanRes?.data?.length) setKazanimlar(kazanRes.data);

            } catch (error) {
                console.error("Directus entegrasyon hatası:", error);
                // Hata durumunda zaten başlangıç değerleri fallback olarak kalacak
            }
        };

        fetchDirectusData();
    }, []);

    useEffect(() => {
        // Anında yukarı sıfırla (hiç animasyon yok)
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant"
        });
    }, [pathname]);

    const faqs = [
        {
            question: "1. Başvuru süreci nasıl ilerler?",
            answer: "Başvurunuzu online form aracılığıyla gönderirsiniz. Ekibimiz ön inceleme yapar, gerekirse ek bilgi talep eder ve sonuç hakkında bilgilendirme yapar. Genellikle 3-5 iş günü içinde ön geri dönüş sağlanır.",
            id: 0
        },
        {
            question: "2. Hangi yayın türleri kabul ediliyor?",
            answer: "Akademik kitaplar, konferans ve armağanlar ve hakemli dergiler gibi birçok akademik yayın türünü kabul ediyoruz. Özel durumlar için destek ekibimizle görüşebilirsiniz.",
            id: 1
        },
        {
            question: "3. Kurumsal e-posta zorunlu mu?",
            answer: "Kurumsal e-posta başvurularda tercih edilir; ancak istisnai durumlarda alternatif iletişim yöntemleri değerlendirilir. Doğrulama sürecinde ek bilgi talep edilebilir.",
            id: 2
        },
        {
            question: "4. Başvuru ne kadar sürede sonuçlanır?",
            answer: "Ön inceleme genellikle 3-5 iş günü içinde tamamlanır. Tam değerlendirme ve sözleşme süreçleri yayın türüne bağlı olarak değişebilir.",
            id: 3
        },
    ];

    // Form state imported from legacy form
    const [publisher, setPublisher] = useState({
        uniqueid: '',
        title: '',
        sorttitle: '',
        parentId: null,
        photo: '',
        contactpersonSaveDTOList: [],
        publishercustomerrepSaveDTOList: [],
        publisherstemplatesandattributedataSaveDTOList: [],
        detailedinformation: {
            taxOffice: '',
            taxNumber: ''
        },
        publicationinformation: {
            name: '',
            editor: '',
            website: '',
            language: '',
            period: '',
            firstPublicationDate: '',
            issn: '',
            eissn: '',
            country: '',
            city: '',
            district: '',
            indexes: ''
        },
        kvkk: 1,
        applicationnote: '',
    });

    const [contacts, setContacts] = useState([{ firstName: '', lastName: '', phone: '', email: '' }]);
    const [contactTouched, setContactTouched] = useState([{ firstName: false, lastName: false, phone: false, email: false }]);
    const [publisherTouched, setPublisherTouched] = useState({
        title: false,
        address: false,
        phone: false,
        email: false
    });

    const [templates, setTemplates] = useState([]);
    const [templateType, setTemplateType] = useState('');
    const [listFrontLoading, setListFrontLoading] = useState(false);
    const [countries, setCountries] = useState([]);
    const [languages, setLanguages] = useState([]);

    // Step state (1..4)
    const [step, setStep] = useState(1);

    // Modal state
    const [showAgreementModal, setShowAgreementModal] = useState(false);
    const [showKvkkModal, setShowKvkkModal] = useState(false);

    // Consent state
    const [agreedToAgreement, setAgreedToAgreement] = useState(false);
    const [agreedToKvkk, setAgreedToKvkk] = useState(false);

    // Success modal state
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');


    useEffect(() => {
        document.title = 'Yayıncı Başvuru | İdeal Online';
        (async () => {
            try {
                setListFrontLoading(true);
                const resp = await templatesListFront(1, token, 0, 10000);
                const data = resp?.data || [];
                setTemplates(data);
                setListFrontLoading(false);
                const def = data.find((t) => t?.name?.toLowerCase?.().includes('yayıncı'));
                if (def) setTemplateType(def.id);
            } catch {
                setTemplates([]);
            }
        })();
    }, []);

    useEffect(() => {
        (async () => {
            try {
                // Fetch countries
                const resC = await getCountryLanguageList(token);
                if (resC?.status === "OK" && resC.data) {
                    const sorted = [...resC.data].sort((a, b) =>
                        (a.countryname || "").localeCompare(b.countryname || "", 'tr')
                    );
                    setCountries(sorted);
                }
                // Fetch languages
                const resL = await getPublicationLanguageList(token);
                if (resL?.status === "OK" && resL.data) {
                    const sorted = [...resL.data].sort((a, b) =>
                        (a.languagename || "").localeCompare(b.languagename || "", 'tr')
                    );
                    setLanguages(sorted);
                }
            } catch (err) {
                console.error("List fetch error:", err);
            }
        })();
    }, [token]);




    const touchContact = (i, field) =>
        setContactTouched((prev) => {
            const cp = [...prev];
            if (!cp[i]) cp[i] = { firstName: false, lastName: false, phone: false, email: false };
            cp[i] = { ...cp[i], [field]: true };
            return cp;
        });

    const touchPublisher = (field) =>
        setPublisherTouched((prev) => ({ ...prev, [field]: true }));


    const handleSubmit = async (e) => {
        if (e && e.preventDefault) e.preventDefault();

        if (isEmpty(publisher.title) || isEmpty(publisher.address) || isEmpty(publisher.phone) || isEmpty(publisher.email)) {
            toast.error('* ile belirtilen zorunlu alanları doldurunuz.');
            setPublisherTouched((p) => ({ ...p, title: true, address: true, phone: true, email: true }));
            setStep(1);
            return;
        }

        if (!agreedToAgreement || !agreedToKvkk) {
            toast.error('Devam etmek için katılım sözleşmesini ve KVKK metnini onaylamanız gerekmektedir.');
            return;
        }

        const c = contacts[0] || {};
        const cInvalid =
            isEmpty(c.firstName) ||
            isEmpty(c.lastName) ||
            isEmpty(c.phone) ||
            !isValidPhone(c.phone) ||
            isEmpty(c.email) ||
            !isValidEmail(c.email);
        if (cInvalid) {
            toast.error('Yetkili bilgilerini kontrol ediniz.');
            setContactTouched([{ firstName: true, lastName: true, phone: true, email: true }]);
            setStep(4);
            return;
        }

        const contactpersonSaveDTOList = contacts.map((x) => ({
            name: x.firstName,
            surname: x.lastName,
            telefon: x.phone,
            eposta: x.email,
            unvan: '',
            job: '',
        }));

        // Manually map Step 1 fields to attribute IDs for backend
        const attributes = [
            { templatesandattributedataid: 296, datajson: [{ lang: 'tr', value: [publisher.address] }], publisherid: 0 },
            { templatesandattributedataid: 297, datajson: [{ lang: 'tr', value: [publisher.phone] }], publisherid: 0 },
            { templatesandattributedataid: 301, datajson: [{ lang: 'tr', value: [publisher.email] }], publisherid: 0 },
            { templatesandattributedataid: 298, datajson: [{ lang: 'tr', value: [publisher.detailedinformation.taxNumber] }], publisherid: 0 },
            { templatesandattributedataid: 299, datajson: [{ lang: 'tr', value: [publisher.detailedinformation.taxOffice] }], publisherid: 0 },
            { templatesandattributedataid: 302, datajson: [{ lang: 'tr', value: [publisher.publicationinformation.country] }], publisherid: 0 },
            { templatesandattributedataid: 303, datajson: [{ lang: 'tr', value: [publisher.publicationinformation.city] }], publisherid: 0 },
            { templatesandattributedataid: 304, datajson: [{ lang: 'tr', value: [publisher.publicationinformation.district] }], publisherid: 0 },
        ];

        const publisherData = {
            uniqueid: publisher.uniqueid?.trim() || '',
            title: publisher.title?.trim(),
            sorttitle: publisher.sorttitle?.trim() || '',
            parentId: publisher.parentId ?? null,
            photo: '',
            contactpersonSaveDTOList,
            publishercustomerrepSaveDTOList: [],
            publisherstemplatesandattributedataSaveDTOList: attributes,
            detailedinformation: {},
            publicationinformation: publisher.publicationinformation,
            kvkk: publisher.kvkk,
            applicationnote: publisher.applicationnote?.trim() || '',
        };

        try {
            const formData = new FormData();
            formData.append('publisherData', JSON.stringify(publisherData));

            const resp = await fetch(
                'https://idealonline.com.tr/service/idealonline/v1/userpanel/userandpublishersCreate',
                {
                    method: 'POST',
                    body: formData,
                }
            );

            const data = await resp.json();
            if (!resp.ok) {
                toast.error(data?.message || 'Bir hata oluştu.');
                return;
            }
            // Success modal instead of toast
            setSuccessMessage(data?.message || 'Başvurunuz alınmıştır. Teşekkür ederiz.');
            setShowSuccessModal(true);
            // Removal of direct navigate as we will handle it in the modal close
        } catch (err) {

            console.error(err);
            toast.error('İstek sırasında bir hata oluştu.');
        }
    };

    // Step navigation helpers
    const goNext = () => {
        if (step === 1) {
            // validate step1 (title, address, phone, email)
            const p = publisher;
            if (isEmpty(p.title) || isEmpty(p.address) || isEmpty(p.phone) || isEmpty(p.email)) {
                toast.error('* ile belirtilen zorunlu alanları doldurunuz.');
                setPublisherTouched({ title: true, address: true, phone: true, email: true });
                return;
            }
            setStep(2);
            return;
        }
        if (step === 2) {
            // validate publication info - Part 1
            const pub = publisher.publicationinformation;
            if (isEmpty(pub.name) || isEmpty(pub.editor)) {
                toast.error('* ile belirtilen zorunlu alanları doldurunuz.');
                return;
            }
            setStep(3);
            return;
        }
        if (step === 3) {
            // validate publication info - Part 2
            const pub = publisher.publicationinformation;
            if (isEmpty(pub.country) || isEmpty(pub.city)) {
                toast.error('* ile belirtilen zorunlu alanları doldurunuz.');
                return;
            }
            setStep(4);
            return;
        }
        if (step === 4) {
            // validate step4 (authorized person)
            const c = contacts[0] || {};
            const cInvalid =
                isEmpty(c.firstName) ||
                isEmpty(c.lastName) ||
                isEmpty(c.phone) ||
                !isValidPhone(c.phone) ||
                isEmpty(c.email) ||
                !isValidEmail(c.email);
            if (cInvalid) {
                toast.error('Yetkili bilgilerini kontrol ediniz.');
                setContactTouched([{ firstName: true, lastName: true, phone: true, email: true }]);
                return;
            }
            setStep(5);
        }
    };

    const goPrev = () => setStep((s) => Math.max(1, s - 1));

    return (
        <div className="main-wrapper">
            <Header2 />
            <main className="mt-5">
                <div className="container">
                    {/* ======================================================= */}
                    {/* BÖLÜM 1: HERO (BAŞLIK ve Açıklama) */}
                    {/* ======================================================= */}
                    <section className="apply-section apply-hero-section mt-5">
                        <div className="apply-hero-container mt-5">
                            <h1 className="apply-hero-title">Yayınlarınızı <span className="brand-ideal">ideal</span><span className="brand-online">online</span>'da Yayınlayın</h1>
                            <p className="apply-hero-description">
                                Idealonline; akademik yayınların erişilebilirliğini, görünürlüğünü ve sürdürülebilirliğini artırmayı amaçlayan kapsamlı bir platformdur. Başvurarak yayınlarınızı geniş bir okuyucu kitlesine ulaştırın.
                            </p>
                        </div>
                    </section>
                    {/* ======================================================= */}
                    {/* BÖLÜM 2: AVANTAJLAR (Avantajlar ve Faydalar) - İKONLAR EKLENDİ */}
                    {/* ======================================================= */}
                    <section className="apply-section apply-advantages-section">
                        <div className="apply-content-container">

                            <div className="advantages-layout">
                                {/* Sol Kısım: İşaretli Liste */}
                                <div className="advantages-list">
                                    <h3 className="apply-section-title">İdealonline'a dahil olduğunuzda kazanacaklarınız</h3>
                                    <ul>
                                        {kazanimlar.map((item, i) => (
                                            <li key={i}>{item.text}</li>
                                        ))}
                                    </ul>
                                </div>

                                {/* Sağ Kısım: Kartlar - İkon Yapısı Eklendi */}
                                <div className="advantages-cards">
                                    {advantages.map((item, i) => {
                                        // ESLint hatasını çözmek için dizideki elemanlara key ekliyoruz
                                        const icons = [
                                            <Globe key="globe" />,
                                            <BarChart2 key="chart" />,
                                            <Lock key="lock" />,
                                            <Shield key="shield" />
                                        ];

                                        return (
                                            <div className="advantage-card" key={i}>
                                                <div className="advantage-icon-wrapper">
                                                    {icons[i] || <Globe />}
                                                </div>
                                                <h4>{item.title}</h4> {/* Directus'tan gelen title */}
                                                <p>{item.description}</p> {/* Directus'tan gelen description */}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                        </div>
                    </section>

                    {/* ======================================================= */}
                    {/* BÖLÜM 3: BAŞVURU SÜRECİ (4 Adımda) - GÜNCELLENDİ */}
                    {/* ======================================================= */}
                    <section className="apply-section apply-process-section">
                        <div className="apply-content-container">
                            <h3 className="apply-process-title">Başvuru Süreci — 4 Adımda</h3>
                            <p className="apply-process-subtitle">Basit ve hızlı adımlarla başvurunuzu tamamlayın.</p>

                            <div className="process-cards-container">
                                {processSteps.map((step, i) => {
                                    const icons = [
                                        <Clipboard key="clip" size={26} color="white" />,
                                        <FileText key="file" size={26} color="white" />,
                                        <Share2 key="share" size={26} color="white" />,
                                        <UserCheck key="user" size={26} color="white" />
                                    ];

                                    return (
                                        <div className="process-card" key={i}>
                                            <div className="process-icon-background">
                                                {icons[i] || <FileText size={26} color="white" />}
                                            </div>
                                            <h4>{step.title}</h4> {/* Directus'tan gelen title */}
                                            <p>{step.description}</p> {/* Directus'tan gelen description */}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </section>

                    {/* ======================================================= */}
                    {/* BÖLÜM 4: BAŞVURU FORMU VE NAVİGASYON */}
                    {/* ======================================================= */}
                    <section className="apply-section apply-main-form-section">
                        <div className="apply-content-container form-content-wrapper">

                            {/* --- YAN NAVİGASYON (ASIDE) --- */}
                            <aside className="form-aside-nav">
                                <div className={`nav-step-item ${step === 1 ? 'active' : ''}`} onClick={() => setStep(1)}>
                                    <div className="nav-step-number-bg">
                                        <span className="nav-step-number">1</span>
                                    </div>
                                    <div className="nav-step-content">
                                        <h5 className="nav-step-title">Yayıncı Bilgileri</h5>
                                        <p className="nav-step-subtitle">Kurum & temel bilgiler</p>
                                    </div>
                                </div>

                                <div className={`nav-step-item ${step === 2 ? 'active' : ''}`} onClick={() => setStep(2)}>
                                    <div className="nav-step-number-bg">
                                        <span className="nav-step-number">2</span>
                                    </div>
                                    <div className="nav-step-content">
                                        <h5 className="nav-step-title">Yayın Bilgileri - 1</h5>
                                        <p className="nav-step-subtitle">Dergi/Yayın adı & Editör</p>
                                    </div>
                                </div>

                                <div className={`nav-step-item ${step === 3 ? 'active' : ''}`} onClick={() => setStep(3)}>
                                    <div className="nav-step-number-bg">
                                        <span className="nav-step-number">3</span>
                                    </div>
                                    <div className="nav-step-content">
                                        <h5 className="nav-step-title">Yayın Bilgileri - 2</h5>
                                        <p className="nav-step-subtitle">Tanımlayıcılar & Yer</p>
                                    </div>
                                </div>

                                <div className={`nav-step-item ${step === 4 ? 'active' : ''}`} onClick={() => setStep(4)}>
                                    <div className="nav-step-number-bg">
                                        <span className="nav-step-number">4</span>
                                    </div>
                                    <div className="nav-step-content">
                                        <h5 className="nav-step-title">Yetkili Kişi Bilgileri</h5>
                                        <p className="nav-step-subtitle">Yetkili kişi & iletişim</p>
                                    </div>
                                </div>

                                <div className={`nav-step-item ${step === 5 ? 'active' : ''}`} onClick={() => setStep(5)}>
                                    <div className="nav-step-number-bg">
                                        <span className="nav-step-number">5</span>
                                    </div>
                                    <div className="nav-step-content">
                                        <h5 className="nav-step-title">Not</h5>
                                        <p className="nav-step-subtitle">Başvuru notu ve gönder</p>
                                    </div>
                                </div>
                            </aside>

                            {/* --- ANA FORM İÇERİĞİ (MAIN) --- */}
                            <div className="form-main-content">

                                {/* İlerleme Çubuğu */}
                                <div className="form-progress-bar-container">
                                    <div className="form-progress-bar" style={{ width: `${(step / 5) * 100}%` }}></div>
                                </div>

                                <div className="form-step-section">

                                    <h2 className="form-section-title">
                                        {step === 1 ? '1. Yayıncı Bilgileri' :
                                            step === 2 ? '2. Yayın Bilgileri - Bölüm 1' :
                                                step === 3 ? '3. Yayın Bilgileri - Bölüm 2' :
                                                    step === 4 ? '4. Yetkili Kişi Bilgileri' : '5. Not'}
                                    </h2>

                                    <div className="form-fields-container">

                                        {step === 1 && (
                                            <>
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label">Kurum Adı <span className="text-danger">*</span></label>
                                                        <input
                                                            className={`form-control ${publisherTouched.title && isEmpty(publisher.title) ? 'is-invalid' : ''}`}
                                                            value={publisher.title}
                                                            onFocus={() => touchPublisher('title')}
                                                            onChange={(e) => setPublisher((p) => ({ ...p, title: e.target.value }))}
                                                            onBlur={() => touchPublisher('title')}
                                                            required
                                                        />
                                                        {publisherTouched.title && isEmpty(publisher.title) && (
                                                            <div className="invalid-feedback">Zorunlu alan</div>
                                                        )}
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label">Adres <span className="text-danger">*</span></label>
                                                        <textarea
                                                            className={`form-control ${publisherTouched.address && isEmpty(publisher.address) ? 'is-invalid' : ''}`}
                                                            rows={2}
                                                            value={publisher.address}
                                                            onFocus={() => touchPublisher('address')}
                                                            onChange={(e) => setPublisher((p) => ({ ...p, address: e.target.value }))}
                                                            onBlur={() => touchPublisher('address')}
                                                            required
                                                        />
                                                        {publisherTouched.address && isEmpty(publisher.address) && (
                                                            <div className="invalid-feedback">Zorunlu alan</div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label">Telefon <span className="text-danger">*</span></label>
                                                        <InputMask
                                                            mask="+99(999)9999999"
                                                            value={publisher.phone}
                                                            onFocus={() => {
                                                                touchPublisher('phone');
                                                                if (!publisher.phone || onlyDigitsLen(publisher.phone) === 0) {
                                                                    setPublisher(p => ({ ...p, phone: '+90' }));
                                                                }
                                                            }}
                                                            onChange={(e) => setPublisher((p) => ({ ...p, phone: e.target.value }))}
                                                            onBlur={() => touchPublisher('phone')}
                                                        >
                                                            {(inputProps) => (
                                                                <input
                                                                    {...inputProps}
                                                                    className={`form-control ${publisherTouched.phone && (isEmpty(publisher.phone) || !isValidPhone(publisher.phone)) ? 'is-invalid' : ''}`}
                                                                    placeholder="+90(555)0000000"
                                                                    required
                                                                />
                                                            )}
                                                        </InputMask>
                                                        {publisherTouched.phone && (isEmpty(publisher.phone) || !isValidPhone(publisher.phone)) && (
                                                            <div className="invalid-feedback">
                                                                {isEmpty(publisher.phone) ? 'Zorunlu alan' : 'Telefon numarası eksik veya maske ile uyumsuz'}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label">E-posta <span className="text-danger">*</span></label>
                                                        <input
                                                            className={`form-control ${publisherTouched.email && (isEmpty(publisher.email) || !isValidEmail(publisher.email)) ? 'is-invalid' : ''}`}
                                                            type="email"
                                                            value={publisher.email}
                                                            onFocus={() => touchPublisher('email')}
                                                            onChange={(e) => setPublisher((p) => ({ ...p, email: e.target.value }))}
                                                            onBlur={() => touchPublisher('email')}
                                                            required
                                                        />
                                                        {publisherTouched.email && (isEmpty(publisher.email) || !isValidEmail(publisher.email)) && (
                                                            <div className="invalid-feedback">
                                                                {isEmpty(publisher.email) ? 'Zorunlu alan' : 'Geçersiz e-posta'}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label">Vergi Dairesi</label>
                                                        <input
                                                            className="form-control"
                                                            value={publisher.detailedinformation.taxOffice}
                                                            onChange={(e) => setPublisher((p) => ({
                                                                ...p,
                                                                detailedinformation: { ...p.detailedinformation, taxOffice: e.target.value }
                                                            }))}
                                                        />
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label">Vergi No</label>
                                                        <input
                                                            className="form-control"
                                                            value={publisher.detailedinformation.taxNumber}
                                                            onChange={(e) => setPublisher((p) => ({
                                                                ...p,
                                                                detailedinformation: { ...p.detailedinformation, taxNumber: e.target.value }
                                                            }))}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        {step === 2 && (
                                            <>
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label">Dergi/Yayın Adı <span className="text-danger">*</span></label>
                                                        <input
                                                            className="form-control"
                                                            value={publisher.publicationinformation.name}
                                                            onChange={(e) => setPublisher(p => ({
                                                                ...p,
                                                                publicationinformation: { ...p.publicationinformation, name: e.target.value }
                                                            }))}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label">Editör <span className="text-danger">*</span></label>
                                                        <input
                                                            className="form-control"
                                                            value={publisher.publicationinformation.editor}
                                                            onChange={(e) => setPublisher(p => ({
                                                                ...p,
                                                                publicationinformation: { ...p.publicationinformation, editor: e.target.value }
                                                            }))}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label">Web Sitesi</label>
                                                        <input
                                                            className="form-control"
                                                            value={publisher.publicationinformation.website}
                                                            onChange={(e) => setPublisher(p => ({
                                                                ...p,
                                                                publicationinformation: { ...p.publicationinformation, website: e.target.value }
                                                            }))}
                                                        />
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label">Yayın Dili</label>
                                                        <select
                                                            className="form-control"
                                                            value={publisher.publicationinformation.language}
                                                            onChange={(e) => setPublisher(p => ({
                                                                ...p,
                                                                publicationinformation: { ...p.publicationinformation, language: e.target.value }
                                                            }))}
                                                        >
                                                            <option value="">Seçiniz...</option>
                                                            {languages.map(l => (
                                                                <option key={l.id} value={l.languagename}>{l.languagename}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label">Periyot</label>
                                                        <input
                                                            className="form-control"
                                                            value={publisher.publicationinformation.period}
                                                            onChange={(e) => setPublisher(p => ({
                                                                ...p,
                                                                publicationinformation: { ...p.publicationinformation, period: e.target.value }
                                                            }))}
                                                        />
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label">İlk Yayın Tarihi</label>
                                                        <input
                                                            className="form-control"
                                                            type="date"
                                                            value={publisher.publicationinformation.firstPublicationDate}
                                                            onChange={(e) => setPublisher(p => ({
                                                                ...p,
                                                                publicationinformation: { ...p.publicationinformation, firstPublicationDate: e.target.value }
                                                            }))}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        {step === 3 && (
                                            <>
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label">ISSN</label>
                                                        <input
                                                            className="form-control"
                                                            value={publisher.publicationinformation.issn}
                                                            onChange={(e) => setPublisher(p => ({
                                                                ...p,
                                                                publicationinformation: { ...p.publicationinformation, issn: e.target.value }
                                                            }))}
                                                        />
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label">E-ISSN</label>
                                                        <input
                                                            className="form-control"
                                                            value={publisher.publicationinformation.eissn}
                                                            onChange={(e) => setPublisher(p => ({
                                                                ...p,
                                                                publicationinformation: { ...p.publicationinformation, eissn: e.target.value }
                                                            }))}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label">Ülke <span className="text-danger">*</span></label>
                                                        <select
                                                            className="form-control"
                                                            value={publisher.publicationinformation.country}
                                                            onChange={(e) => setPublisher(p => ({
                                                                ...p,
                                                                publicationinformation: { ...p.publicationinformation, country: e.target.value }
                                                            }))}
                                                            required
                                                        >
                                                            <option value="">Seçiniz...</option>
                                                            {countries.map(c => (
                                                                <option key={c.id} value={c.countryname}>{c.countryname}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-4 mb-3">
                                                        <label className="form-label">Şehir (İl) <span className="text-danger">*</span></label>
                                                        <input
                                                            className="form-control"
                                                            value={publisher.publicationinformation.city}
                                                            onChange={(e) => setPublisher(p => ({
                                                                ...p,
                                                                publicationinformation: { ...p.publicationinformation, city: e.target.value }
                                                            }))}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="col-md-4 mb-3">
                                                        <label className="form-label">İlçe <span className="text-danger">*</span></label>
                                                        <input
                                                            className="form-control"
                                                            value={publisher.publicationinformation.district}
                                                            onChange={(e) => setPublisher(p => ({
                                                                ...p,
                                                                publicationinformation: { ...p.publicationinformation, district: e.target.value }
                                                            }))}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12 mb-3">
                                                        <label className="form-label">Yer Aldığı İndeksler</label>
                                                        <textarea
                                                            className="form-control"
                                                            rows={2}
                                                            value={publisher.publicationinformation.indexes}
                                                            onChange={(e) => setPublisher(p => ({
                                                                ...p,
                                                                publicationinformation: { ...p.publicationinformation, indexes: e.target.value }
                                                            }))}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        {step === 4 && (
                                            <>
                                                {contacts.map((c, i) => {
                                                    const firstNameInvalid = isEmpty(c.firstName);
                                                    const lastNameInvalid = isEmpty(c.lastName);
                                                    const phoneInvalid = isEmpty(c.phone) || !isValidPhone(c.phone);
                                                    const emailInvalid = isEmpty(c.email) || !isValidEmail(c.email);
                                                    const t = contactTouched[i] || { firstName: false, lastName: false, phone: false, email: false };

                                                    return (
                                                        <div key={i} className="mb-3">
                                                            <div className="row">
                                                                <div className="col-md-6 mb-3">
                                                                    <label className="form-label">
                                                                        Yetkili Adı <span className="text-danger">*</span>
                                                                    </label>
                                                                    <input
                                                                        className={`form-control ${t.firstName && firstNameInvalid ? 'is-invalid' : ''}`}
                                                                        value={c.firstName}
                                                                        onFocus={() => touchContact(i, 'firstName')}
                                                                        onChange={(e) =>
                                                                            setContacts((prev) =>
                                                                                prev.map((cc, idx) => (idx === i ? { ...cc, firstName: e.target.value } : cc))
                                                                            )
                                                                        }
                                                                        onBlur={() => touchContact(i, 'firstName')}
                                                                        required
                                                                    />
                                                                    {t.firstName && firstNameInvalid && (
                                                                        <div className="invalid-feedback">Zorunlu alan</div>
                                                                    )}
                                                                </div>

                                                                <div className="col-md-6 mb-3">
                                                                    <label className="form-label">
                                                                        Yetkili Soyadı <span className="text-danger">*</span>
                                                                    </label>
                                                                    <input
                                                                        className={`form-control ${t.lastName && lastNameInvalid ? 'is-invalid' : ''}`}
                                                                        value={c.lastName}
                                                                        onFocus={() => touchContact(i, 'lastName')}
                                                                        onChange={(e) =>
                                                                            setContacts((prev) =>
                                                                                prev.map((cc, idx) => (idx === i ? { ...cc, lastName: e.target.value } : cc))
                                                                            )
                                                                        }
                                                                        onBlur={() => touchContact(i, 'lastName')}
                                                                        required
                                                                    />
                                                                    {t.lastName && lastNameInvalid && (
                                                                        <div className="invalid-feedback">Zorunlu alan</div>
                                                                    )}
                                                                </div>

                                                                <div className="col-md-6 mb-3">
                                                                    <label className="form-label">
                                                                        Yetkili Telefon <span className="text-danger">*</span>
                                                                    </label>
                                                                    <InputMask
                                                                        mask="+99(999)9999999"
                                                                        value={c.phone}
                                                                        onFocus={() => {
                                                                            touchContact(i, 'phone');
                                                                            if (!c.phone || onlyDigitsLen(c.phone) === 0) {
                                                                                setContacts((prev) =>
                                                                                    prev.map((cc, idx) => (idx === i ? { ...cc, phone: '+90' } : cc))
                                                                                );
                                                                            }
                                                                        }}
                                                                        onChange={(e) =>
                                                                            setContacts((prev) =>
                                                                                prev.map((cc, idx) => (idx === i ? { ...cc, phone: e.target.value } : cc))
                                                                            )
                                                                        }
                                                                        onBlur={() => touchContact(i, 'phone')}
                                                                    >
                                                                        {(inputProps) => (
                                                                            <input
                                                                                {...inputProps}
                                                                                className={`form-control ${t.phone && phoneInvalid ? 'is-invalid' : ''}`}
                                                                                placeholder="+90(555)0000000"
                                                                                required
                                                                            />
                                                                        )}
                                                                    </InputMask>
                                                                    {t.phone && phoneInvalid && (
                                                                        <div className="invalid-feedback">
                                                                            {isEmpty(c.phone)
                                                                                ? 'Zorunlu alan'
                                                                                : 'Telefon numarası eksik veya maske ile uyumsuz'}
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                <div className="col-md-6 mb-3">
                                                                    <label className="form-label">
                                                                        Yetkili E-posta <span className="text-danger">*</span>
                                                                    </label>
                                                                    <input
                                                                        className={`form-control ${t.email && emailInvalid ? 'is-invalid' : ''}`}
                                                                        type="email"
                                                                        value={c.email}
                                                                        onFocus={() => touchContact(i, 'email')}
                                                                        onChange={(e) =>
                                                                            setContacts((prev) =>
                                                                                prev.map((cc, idx) => (idx === i ? { ...cc, email: e.target.value } : cc))
                                                                            )
                                                                        }
                                                                        onBlur={() => touchContact(i, 'email')}
                                                                        required
                                                                    />
                                                                    {t.email && emailInvalid && (
                                                                        <div className="invalid-feedback">
                                                                            {isEmpty(c.email) ? 'Zorunlu alan' : 'Geçersiz e-posta'}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </>
                                        )}

                                        {step === 5 && (
                                            <>
                                                <div className="row">
                                                    <div className="col-md-12 mb-3">
                                                        <label className="form-label">Başvuru Notu</label>
                                                        <textarea
                                                            className="form-control"
                                                            rows={4}
                                                            placeholder="Notunuz varsa lütfen belirtiniz."
                                                            value={publisher.applicationnote}
                                                            onChange={(e) =>
                                                                setPublisher((p) => ({ ...p, applicationnote: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <div className="col-md-12">
                                                        <div className="form-check mb-2">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id="agreeAgreement"
                                                                checked={agreedToAgreement}
                                                                onChange={(e) => setAgreedToAgreement(e.target.checked)}
                                                            />
                                                            <label className="form-check-label" htmlFor="agreeAgreement" style={{ fontSize: '0.9rem' }}>
                                                                <span
                                                                    onClick={() => setShowAgreementModal(true)}
                                                                    style={{ color: '#007bff', cursor: 'pointer', fontWeight: '500' }}
                                                                >
                                                                    Katılım Sözleşmesini
                                                                </span> okudum, kabul ediyorum. <span className="text-danger">*</span>
                                                            </label>
                                                        </div>

                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id="agreeKvkk"
                                                                checked={agreedToKvkk}
                                                                onChange={(e) => setAgreedToKvkk(e.target.checked)}
                                                            />
                                                            <label className="form-check-label" htmlFor="agreeKvkk" style={{ fontSize: '0.9rem' }}>
                                                                <span
                                                                    onClick={() => setShowKvkkModal(true)}
                                                                    style={{ color: '#007bff', cursor: 'pointer', fontWeight: '500' }}
                                                                >
                                                                    KVKK metnini
                                                                </span> okudum, kabul ediyorum. <span className="text-danger">*</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                    </div>

                                    {/* Butonlar */}
                                    <div className="form-actions">
                                        <button className="form-button btn-prev" onClick={goPrev} disabled={step === 1}>Geri</button>
                                        {step < 5 ? (
                                            <button className="form-button btn-next" onClick={goNext}>İleri</button>
                                        ) : (
                                            <button className="form-button btn-next" onClick={handleSubmit}>Başvuruyu Gönder</button>
                                        )}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </section>
                    <section className="apply-section apply-faq-support-section">

                        {/* Sayfa içeriğini merkezleyen ana konteyner (max-width: 1440px) */}
                        <div className="apply-content-container form-and-support-layout">

                            {/* --- SOL KISIM: SSS Akordiyon Alanı (faq-accordion-area) --- */}
                            <div className="faq-accordion-area">
                                {sss.map((faq, index) => (
                                    <div key={index} className="faq-item-border">
                                        <div
                                            className="faq-question-button"
                                            onClick={() => setOpenFaq(openFaq === index ? null : index)}
                                        >
                                            <h4 className="faq-question-text">{faq.title}</h4>
                                        </div>
                                        {openFaq === index && (
                                            <div className="faq-answer-region">
                                                <p className="faq-answer-text">{faq.description}</p>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>

                            {/* --- SAĞ KISIM: Destek ve İletişim Alanı (support-area) --- */}
                            <div className="support-area">
                                <div className="support-box-background">

                                    {/* 1. İKON BÖLÜMÜ */}
                                    <div className="support-icon-circle">
                                        {/* İkonunuzun tam Figma çıktısına yakın olması için FaInfoCircle kullandık */}
                                        <i className="fa-solid fa-question" />
                                    </div>

                                    {/* 2. BAŞLIK VE AÇIKLAMA */}
                                    <h3 className="support-title">Destek ve İletişim</h3>
                                    <p className="support-description">
                                        İdealonline ekibi olarak yayıncılarımızın her zaman yanında olmaktan mutluluk duyuyoruz. Ekibimiz en kısa sürede dönüş yaparak sürecin sorunsuz ilerlemesini sağlar.
                                    </p>

                                    {/* 3. İLETİŞİM BİLGİLERİ */}
                                    <div className="contact-info-wrapper">

                                        {/* --- TELEFON --- */}
                                        <div className="contact-item">
                                            <div className="contact-icon-border">
                                                {/* Telefon İkonu */}
                                                <Phone />
                                            </div>
                                            <div>
                                                <p className="contact-title">Teknik Destek Hattımız</p>
                                                <p className="contact-detail">+90 212 528 85 41</p>
                                            </div>
                                        </div>

                                        {/* --- E-POSTA --- */}
                                        <div className="contact-item">
                                            <div className="contact-icon-border">
                                                {/* E-Posta İkonu */}
                                                <Mail />
                                            </div>
                                            <div>
                                                <p className="contact-title">E-Posta Adresimiz</p>
                                                <p className="contact-detail">idealonline@idealkultur.com</p>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>

                        </div>
                    </section>
                    <section className="apply-section apply-cta-section">

                        {/* İçeriği merkeze alan ana konteyner (max-width: 1440px) */}
                        <div className="apply-content-container mb-5">

                            {/* CTA Arka Plan Kutusu */}
                            <div className="apply-cta-wrapper ">

                                {/* İçerik ve Padding Alanı */}
                                <div className="apply-cta-content">

                                    {/* Başlık */}
                                    <h2 className="apply-cta-title">
                                        Bugün başvurunuzu yapın, yayınlarınızı idealonline ile binlerce kullanıcıya ulaştırın!
                                    </h2>

                                    {/* Açıklama Metni */}
                                    <p className="apply-cta-description">
                                        Siz değerli yayıncılarımızın katkılarıyla, akademik dünyaya daha geniş bir perspektif sunuyor, bilgiye erişimi daha kolay ve etkili hale getiriyoruz.
                                    </p>

                                </div>

                            </div>

                        </div>
                    </section>
                </div>
            </main>
            <ToastContainer position="top-right" autoClose={3000} />
            <Footer2 />

            <ParticipationAgreementModal
                show={showAgreementModal}
                handleClose={() => setShowAgreementModal(false)}
                publisherName={publisher.title}
            />
            <KvkkModal
                show={showKvkkModal}
                handleClose={() => setShowKvkkModal(false)}
            />

            <ApplySuccessModal
                show={showSuccessModal}
                message={successMessage}
                handleClose={() => {
                    setShowSuccessModal(false);
                    navigate('/home');
                }}
            />
        </div>
    );
};

export default ApplyPage;